import hashtagRegex from 'hashtag-regex'

export const HASHTAG_LIMIT = 5
const regex = hashtagRegex()

export const countHashtagsInText = (text: string): number => {
  let counter = 0

  while (regex.exec(text)) {
    counter += 1
  }

  return counter
}

export const countRemainingHashtags = (text: string): number => {
  return HASHTAG_LIMIT - countHashtagsInText(text)
}

export default countRemainingHashtags
